<template>
  <v-container>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-app-bar color="transparent" flat>
            <v-toolbar-title class="primary--text"
              >Solicitudes de contacto</v-toolbar-title
            >
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="table.search"
              label="Buscar"
              prepend-icon="search"
            ></v-text-field>
          </v-app-bar>
          <v-data-table
            :headers="table.headers"
            :items="requests"
            :search="table.search"
            :loading="table.loading"
            no-results-text="Sin resultados"
            no-data-text="Sin elementos"
            footer-props.items-per-page-text="Filas por página"
          >
            <template v-slot:item.created="{ item }">
              <div>
                {{ item.created | date }}
              </div>
            </template>
            <template v-slot:item.userName="{ item }">
              <div>
                {{ item.userName == undefined ? "Sin nombre" : item.userName }}
              </div>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import { formatDateNew, formatPhone } from "../../filters";

export default {
  name: "Contact-Request",
  filters: {
    date(timestamp) {
      return formatDateNew(timestamp);
    },
    phone(number) {
      return formatPhone(number);
    },
  },
  data: () => ({
    table: {
      search: "",
      loading: false,
      pagination: {
        sortBy: "created",
        descending: true,
      },
      headers: [
        { text: "Nombre", value: "userName" },
        { text: "Correo Electronico", value: "email" },
        { text: "Teléfono", value: "phone" },
        { text: "Mensaje", value: "message" },
        { text: "Fecha ", value: "created" },
      ],
    },
  }),
  created() {
    this.table.loading = true;
    this.loadRequests().then(() => (this.table.loading = false));
  },
  computed: mapGetters({ requests: "contactRequests" }),
  methods: {
    customFilter(items, search, filter) {
      search = search.toString().toLowerCase();
      return items.filter((i) =>
        Object.keys(i).some((j) => {
          if (j === "created")
            return filter(
              this.$moment(i[j]).format("DD/MM/YYYY hh:mm a"),
              search
            );
          return filter(i[j], search);
        })
      );
    },
    ...mapActions(["loadRequests"]),
  },
};
</script>
